import AxiosInstance from 'src/shared/services/axios/interceptor';

const controller = 'HealthCheck';

export interface HealthCheckCategoryResponse {
  key: string;
  label: string;
  count: number;
  supportsAutoFix: boolean;
}

export interface MemberHealthCheckIssueResponse {
  memberId: number;
  memberNr: string | null;
  firstName: string;
  lastName: string;
  currentValue: string | null;
  suggestedValue: string | null;
  description: string;
  groupLabel: string | null;
  postNr: string | null;
}

const buildScopeQuery = (associationId?: number, districtId?: number): string => {
  const params: string[] = [];
  if (associationId) params.push(`associationId=${associationId}`);
  if (districtId) params.push(`districtId=${districtId}`);
  return params.length ? `?${params.join('&')}` : '';
};

export const getMemberHealthCheckSummary = (associationId?: number, districtId?: number) =>
  AxiosInstance.get<HealthCheckCategoryResponse[]>(`${controller}/Members/Summary${buildScopeQuery(associationId, districtId)}`);

export const getMemberHealthCheckCategoryCount = (key: string, associationId?: number, districtId?: number) =>
  AxiosInstance.get<HealthCheckCategoryResponse>(`${controller}/Members/${key}/Count${buildScopeQuery(associationId, districtId)}`);

export const getMemberHealthCheckIssues = (key: string, associationId?: number, districtId?: number) =>
  AxiosInstance.get<MemberHealthCheckIssueResponse[]>(`${controller}/Members/${key}${buildScopeQuery(associationId, districtId)}`);

export const applyMemberHealthCheckFix = (key: string, memberId: number) =>
  AxiosInstance.post<boolean>(`${controller}/Members/${key}/Fix/${memberId}`);

export interface HealthCheckBulkFixResponse {
  applied: number;
  failed: number;
}

export const applyAllMemberHealthCheckFixes = (key: string, associationId?: number, districtId?: number) =>
  AxiosInstance.post<HealthCheckBulkFixResponse>(`${controller}/Members/${key}/FixAll${buildScopeQuery(associationId, districtId)}`);
